<template>
  <div
    class="flex bg-neutral-secondary rounded-md h-full"
    :class="[vertical ? 'flex-col-reverse justify-end h-full' : 'm-1 p-1']"
  >
    <div
      class="flex w-full"
      :class="{
        'flex-col overflow-y-scroll': vertical,
      }"
    >
      <div
        class="basis-1/3 2xl:basis-[30%] bg-neutral-primary rounded-md"
        :class="{ 'mx-2 mb-2 mt-1 order-last': vertical }"
      >
        <SymbolTradeInfo
          :symbol="symbol"
          :portfolio-detail="portfolioQuantity"
          :vertical="false"
          :show-bubble="showBubble"
        />
      </div>

      <div
        class="flex flex-col w-full basis-2/3 2xl:basis-[70%]"
        :class="[vertical ? 'px-2 pt-1' : 'mr-1  overflow-y-scroll']"
      >
        <SymbolPriceChart
          :lower-price-threshold="symbol.lowerPriceThreshold ?? 0"
          :upper-price-threshold="symbol.upperPriceThreshold ?? 0"
          :highest-trade-price="symbol.highestTradePrice ?? 0"
          :lowest-trade-price="symbol.lowestTradePrice ?? 0"
          :reference-price="symbol.referencePrice ?? 0"
          :last-price="symbol.lastTradePrice ?? 0"
          :instrument-type-code="symbol.instrumentTypeCode ?? ''"
          :previous-day-price="symbol.previousDayPrice ?? 0"
          :size="vertical ? 'small' : 'large'"
        />

        <SymbolBidAskTable
          :items="symbol.bidAsk"
          :isin="symbol.isin ?? ''"
          :lower-price-threshold="symbol.lowerPriceThreshold ?? 0"
          :upper-price-threshold="symbol.upperPriceThreshold ?? 0"
          :change-route="true"
          :show-unit="Boolean(vertical)"
          :size="vertical ? 'small' : 'large'"
        />

        <SymbolIndividualFirmInfo
          :symbol="symbol"
          :size="vertical ? 'small' : 'large'"
        />
      </div>
    </div>

    <NBox
      v-if="vertical"
      :rounded="false"
      elevation="medium"
      class="px-3 py-2 rounded-t-md z-20"
    >
      <SymbolInfoCard
        hide-chart
        :symbol="symbol"
        :is-market-map="isMarketMap"
      />
    </NBox>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { Instrument, PortfolioItem } from '@libs/api-reference';

import {
  SymbolBidAskTable,
  SymbolIndividualFirmInfo,
  SymbolInfoCard,
  SymbolPriceChart,
  SymbolTradeInfo,
} from '@/modules/symbol';

type SymbolDetailPropsType = {
  vertical?: boolean;
  portfolioSymbols?: PortfolioItem[] | null;
  symbol: Instrument;
  isMarketMap?: boolean;
  showBubble?: boolean;
  isAccordionLayout?: boolean;
};

const props = withDefaults(defineProps<SymbolDetailPropsType>(), {
  vertical: false,
  portfolioSymbols: () => [],
  isMarketMap: false,
  showBubble: false,
  isAccordionLayout: false,
});

const portfolioQuantity = computed(() => {
  if (props.portfolioSymbols) {
    const symbol = props.portfolioSymbols?.find(
      (portfolioSymbol) =>
        portfolioSymbol.instrumentIsin?.substring(0, 11) ===
        props.symbol.isin?.substring(0, 11)
    );

    return {
      quantity: symbol?.quantity ?? 0,
      percentageValue: symbol?.returnValuePercentage ?? 0,
    };
  }

  return null;
});
</script>
